<script setup lang="ts">
import { TableCell, TableRow } from '~/components/ui/table'

defineProps<{ count?: number }>()
</script>

<template>
  <TableRow v-for="i in (count ?? 5)" :key="i">
    <TableCell v-for="col in 6" :key="col">
      <div class="h-4 w-full animate-pulse rounded bg-gray-200" />
    </TableCell>
  </TableRow>
</template>
